import { Text } from '#app/components/Primitives/Text.js';
import { type ReactNode } from 'react';

type CellLayoutProps = { readonly children: ReactNode };

export const CellLayout = ({ children }: CellLayoutProps) => {
  return (
    <Text
      as="div"
      color="gray90"
      textStyle="bodySmall"
    >
      {children}
    </Text>
  );
};
